import { withRouter } from 'react-router';
import { breadcrumbs } from '@inqool/uas-web-core/es/utils';
import Dictionary from '@inqool/uas-web-core/es/components/app/Dictionary';
import { compose, setDisplayName, onlyUpdateForKeys, withProps } from 'recompose';
import * as React from 'react';
import { withClassname } from '@components/hoc/withClassname';
import { CalendarsForm } from '@modules/hr-templates/calendars/CalendarsForm';
import { withAdditionalProps } from '@components/hoc/withAdditionalProps';
import { withColumns } from '@components/hoc/withColumns';
import { Agenda } from '@modules/columnSettings/_columnSettingsEnums';
import { ColumnManager } from '@modules/columnSettings/ColumnManager';

export const calendarsUrl = '/metropolis/api/hr/workplan/calendar';
export const calendarsLabel = 'Personalistika - šablony kalendáře';
export const calendarsPath = '/hr/templates/calendars';
export const calendarsGridName = 'CalendarsGrid';
export const CalendarsGrid = compose(
  withRouter,
  setDisplayName(calendarsGridName),
  onlyUpdateForKeys(['url', 'location']),
  breadcrumbs([{ label: calendarsLabel }]),
  withColumns(Agenda.CALENDARS),
  withProps(({ columns }) => ({
    name: calendarsGridName,
    url: calendarsUrl,
    Form: CalendarsForm,
    dialog: false,
    gridProps: {
      columns,
      filterRow: true,
      showCheckboxes: true,
      deleting: true,
      filtering: true,
      locale: 'cz',
      adding: true,
      version: 7,
      ActionBar: () => <ColumnManager agenda={Agenda.CALENDARS} />
    }
  })),
  withAdditionalProps,
  withClassname({ className: 'mp-grid' })
)(Dictionary);



// WEBPACK FOOTER //
// ./src/modules/hr-templates/calendars/CalendarsGrid.tsx